// Companies API — Phase 1 Plan 05.
//
// POST /api/v1/companies — atomic registration + 30-day trial activation.

import type { ApiClient } from "./client";

export interface CompanyCreate {
  name: string;
  country: string;
  vat_id?: string | null;
  vat_country?: string | null;
  contact_email: string;
  locale: string;
  phone?: string | null;
}

export interface CompanyResponse {
  company_id: number;
  trial_ends_at: string; // ISO 8601 UTC
  vat_verification_status: string;
  plan: string;
}

export async function createCompany(
  client: ApiClient,
  payload: CompanyCreate,
): Promise<CompanyResponse> {
  // Drop undefined/empty optional fields — server validates per Pydantic schema.
  const cleaned: Record<string, unknown> = {
    name: payload.name,
    country: payload.country,
    contact_email: payload.contact_email,
    locale: payload.locale,
  };
  if (payload.vat_id?.trim()) {
    cleaned.vat_id = payload.vat_id.trim();
    cleaned.vat_country = payload.vat_country ?? payload.country;
  }
  if (payload.phone?.trim()) {
    cleaned.phone = payload.phone.trim();
  }
  return client.post<CompanyResponse>("/api/v1/companies", cleaned);
}
